import { request } from './httpClient';

export interface NotificationCTA {
  label: string;
  url: string;
}

export interface NotificationItem {
  id: number;
  title: string;
  body: string;
  ctas: NotificationCTA[];
  sent_at: string;
  viewed_at: string | null;
  email_opened_at: string | null;
  client_id: number | null;
  client_name: string | null;
  client_logo: string | null;
  client_colour: string | null;
}

export interface NotificationsListResponse {
  success: boolean;
  data: {
    notifications: NotificationItem[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
  };
  error: string | null;
}

export interface MarkViewedResponse {
  success: boolean;
  data: { message: string };
  error: string | null;
}

const SAFE_LINK_URL = 'https://api.gate.haus/v2/safelink.php';

export const notificationsService = {
  async list({ page = 1, perPage = 20 }: { page?: number; perPage?: number } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('per_page', String(perPage));
    const response = await request<NotificationsListResponse>(`/v2/notifications/list.php?${params.toString()}`);
    if (!response.success) {
      throw new Error(response.error || 'Failed to load notifications');
    }
    return response;
  },
  async markViewed(notificationId: number) {
    const response = await request<MarkViewedResponse>('/v2/notifications/mark-viewed.php', {
      method: 'POST',
      body: JSON.stringify({ notification_id: notificationId })
    });
    if (!response.success) {
      throw new Error(response.error || 'Failed to mark notification viewed');
    }
    return response;
  },
  safeLinkUrl(url: string) {
    const params = new URLSearchParams();
    params.set('url', url);
    return `${SAFE_LINK_URL}?${params.toString()}`;
  }
};
